import React from 'react';

const technicalSkills = [
    ['PostgreSQL', 'bx bxl-postgresql'],
    ['Microsoft SQL Server', 'bx bx-data'],
    ['T-SQL', 'bx bx-data'],
    ['MySQL', 'bx bxs-data'],
    ['SQLite', 'bx bx-data'],
    ['NoSQL', 'bx bx-collection'],
    ['Redis', 'bx bx-memory-card'],
    ['Docker', 'bx bxl-docker'],
    ['Azure DevOps', 'bx bxl-microsoft'],
    ['Git', 'bx bxl-git'],
    ['Jira', 'bx bx-task'],
    ['Visual SVN', 'bx bx-git-compare'],
    ['Windows Server', 'bx bx-server'],
    ['Ubuntu', 'bx bxl-ubuntu']
];

const Technical = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title bold">Databases, DevOps & Tools</h3>
            <div className="skills__box">
                {technicalSkills.map(([name, icon]) => (
                    <div className="skills__data" key={name}>
                        <i className={icon}></i>
                        <h3 className="skills__name">{name}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Technical;
